import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";

export const useMyPublicationCollaboratorsApplicantFeedStore = defineSmartFeedPiniaStore(
  "my-publication-collaborators-applicant-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          "key": "publication_id",
          "payload": useCreatorPublicationStore().publicationId,
        },
        collaboratorType: {
          "key": "collaborator_type",
          "payload": "applicant",
        },
      },
      tableFields: [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "role", label: "Role" },
        { key: "collaboratorStatus", label: "Type" },
        { key: "compensation", label: "Compensation" },
        { key: "status", label: "Status" },
        { key: "actions", label: "" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/publication/${useCreatorPublicationStore().publicationId}/collaborators/filtered`;
      },
    },
  },
);
